import { makeStyles } from '@mui/styles';
import { Colors } from '../../../theme/colors';

export const useDeliveryContainerReserveesStyles = makeStyles(() => ({
  root: {
    backgroundColor: Colors.darkGray,
    color: 'white',
    borderRadius: '6px',
    fontSize: '10px',
    // Max char length is 8, so we can set a max width of 8ch
    maxWidth: '8ch',
    height: '20px',
    lineHeight: '20px',
    // Truncate text if it exceeds max width
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    padding: '1px'
  },
  label: {
    padding: '2px'
  },
  minimised: {
    // Displayed as a fixed dot; the full name is surfaced via the hover tooltip instead of expanding.
    width: '10px',
    height: '10px',
    minWidth: '10px',
    maxWidth: '10px',
    padding: 0,
    borderRadius: '50%'
  },
  minimisedLabel: {
    opacity: 0,
    padding: 0,
    width: 0,
    overflow: 'hidden'
  },
  tooltip: {
    fontSize: '12px'
  }
}));
